import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { tv } from '@costar-ui/cosmos';
import { ModalContextProvider } from '@costar-ui/share-context';
import React__default, { useCallback, useMemo } from 'react';
import { composeRenderProps } from 'react-aria-components';
import AriaModal from './aria/modal.esm.js';
import ModalOverlay from './aria/modal-overlay.esm.js';
import { useComponentTheme } from '../../../theme/theme.context.esm.js';

var _excluded = ["className", "size", "fullHeight", "shouldHideBackgroundOnHidden", "allowOverflowModal", "maxHeight", "maxWidth", "marginTop"];
var overlayStyles = tv({
  base: ['fixed', 'inset-0', 'isolate', 'z-50', 'flex', 'h-[--visual-viewport-height]', 'w-full', 'bg-base-inverse/[35%]', 'p-4', 'text-center', 'print:relative', 'print:flex-none', 'print:p-0', 'print:h-max'],
  variants: {
    shouldHideBackgroundOnHidden: {
      "true": 'data-[hidden=true]:bg-transparent'
    },
    allowOverflowModal: {
      "false": ['items-center', 'justify-center'],
      "true": 'overflow-y-auto'
    }
    // isEntering: {
    //   true: 'duration-200 ease-out animate-in fade-in'
    // },
    // isExiting: {
    //   true: 'duration-200 ease-in animate-out fade-out'
    // }
  }
});
var defaultCustomSize = {
  maxWidth: '121.875rem',
  marginTop: '14.375rem'
};
function PrimitiveModal(_ref) {
  var _className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'std' : _ref$size,
    fullHeight = _ref.fullHeight,
    _ref$shouldHideBackgr = _ref.shouldHideBackgroundOnHidden,
    shouldHideBackgroundOnHidden = _ref$shouldHideBackgr === void 0 ? true : _ref$shouldHideBackgr,
    _ref$allowOverflowMod = _ref.allowOverflowModal,
    allowOverflowModal = _ref$allowOverflowMod === void 0 ? false : _ref$allowOverflowMod,
    maxHeight = _ref.maxHeight,
    _maxWidth = _ref.maxWidth,
    _marginTop = _ref.marginTop,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useComponentTheme('Modal');
  var ariaModalClasses = useCallback(function (renderProps) {
    return theme(_objectSpread2(_objectSpread2({}, renderProps), {}, {
      asBlock: allowOverflowModal,
      size: size,
      fullHeight: fullHeight || !!maxHeight
    }));
  }, [theme, fullHeight, maxHeight, size, allowOverflowModal]);
  var overlayClasses = useMemo(function () {
    return composeRenderProps(_className, function (className, renderProps) {
      var classNames = overlayStyles(_objectSpread2(_objectSpread2({}, renderProps), {}, {
        shouldHideBackgroundOnHidden: shouldHideBackgroundOnHidden,
        allowOverflowModal: allowOverflowModal,
        className: className
      }));
      return "csg-tw-modal-overlay ".concat(classNames);
    });
  }, [_className, shouldHideBackgroundOnHidden, allowOverflowModal]);
  var customSize = useMemo(function () {
    if (size === 'fill') {
      return _objectSpread2(_objectSpread2(_objectSpread2({}, defaultCustomSize), _maxWidth ? {
        maxWidth: _maxWidth
      } : {}), _marginTop ? {
        marginTop: _marginTop
      } : {});
    }
    return {};
  }, [size, _maxWidth, _marginTop]);
  return /*#__PURE__*/React__default.createElement(ModalContextProvider, null, /*#__PURE__*/React__default.createElement(ModalOverlay, _extends({}, props, {
    className: overlayClasses
  }), /*#__PURE__*/React__default.createElement(AriaModal, _extends({}, props, customSize, {
    maxHeight: maxHeight,
    className: ariaModalClasses
  }))));
}

export { PrimitiveModal as default };
//# sourceMappingURL=modal.esm.js.map
